import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  Modal,
  Paper,
  Button,
  Collapse,
  IconButton
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ModalTableOfEmployees from './ModalTableOfEmployees';
import i18n from '../../i18n';

import '../../assets/stylesheets/ScheduleView.css';

class SendReleaseModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandView: false
    };
  }

  handleExpandClick = () => {
    this.setState(prevState => ({ expandView: !prevState.expandView }));
  };

  generateAdditionalDetails = () => {
    const { expandView } = this.state;
    const { releaseModalData } = this.props;
    const {
      fullTimeEmployees,
      unbookedEmployees,
      canceledEmployees,
      declinedEmployees,
      emailNotSentEmployees,
      expiredBookingEmployees
    } = releaseModalData;

    if (
      fullTimeEmployees.length === 0 &&
      unbookedEmployees.length === 0 &&
      canceledEmployees.length === 0 &&
      declinedEmployees.length === 0 &&
      emailNotSentEmployees.length === 0 &&
      expiredBookingEmployees.length === 0
    ) {
      // No additional details to show
      return;
    }

    // eslint-disable-next-line consistent-return
    return (
      <>
        <div className="showDetailsLabel">
          {i18n.t('schedule:showAdditionalDetails')}
          <IconButton
            className={expandView ? 'expandView' : ''}
            onClick={this.handleExpandClick}
            aria-expanded={expandView}
            aria-label={i18n.t('schedule:showMore')}
          >
            <ExpandMoreIcon color="secondary" />
          </IconButton>
        </div>

        <Collapse
          in={expandView}
          timeout="auto"
          className="showDetailsContainer"
        >
          {expiredBookingEmployees.length !== 0 ? (
            <>
              <ModalTableOfEmployees
                label='pastBooking'
                employees={expiredBookingEmployees}
                rowStyle='dateExpired'
              />
              <br />
            </>
          ) : null}
          {emailNotSentEmployees.length !== 0 ? (
            <>
              <ModalTableOfEmployees
                label='confirmationEmailNotSent'
                employees={emailNotSentEmployees}
                rowStyle='emailNotSent'
              />
              <br />
            </>
          ) : null}
          {fullTimeEmployees.length !== 0 ? (
            <>
              <ModalTableOfEmployees
                label='sendFullTimeReleaseEmails'
                employees={fullTimeEmployees}
              />
              <br />
            </>
          ) : null}
          {unbookedEmployees.length !== 0 ? (
            <>
              <ModalTableOfEmployees
                label='sendUnbookedReleaseEmails'
                employees={unbookedEmployees}
                rowStyle='unbookedFreelancer'
              />
              <br />
            </>
          ) : null}
          {canceledEmployees.length !== 0 ? (
            <>
              <ModalTableOfEmployees
                label='sendCanceledReleaseEmails'
                employees={canceledEmployees}
                rowStyle='canceled'
              />
              <br />
            </>
          ) : null}
          {declinedEmployees.length !== 0 ? (
            <>
              <ModalTableOfEmployees
                label='sendDeclinedReleaseEmails'
                employees={declinedEmployees}
                rowStyle='declined'
              />
              <br />
            </>
          ) : null}
        </Collapse>
      </>
    );
  };

  render() {
    const {
      showModal,
      onCloseReleaseModal,
      onClickSendReleaseEmails,
      releaseModalData
    } = this.props;

    const showNoEmployeesToSendEmailsMsg =
      releaseModalData.confirmedEmployees.length === 0 &&
      releaseModalData.unconfirmedEmployees.length === 0;
    return (
      <Modal open={showModal} onClose={onCloseReleaseModal}>
        <Paper className="validationModal">
          <h2>{i18n.t('schedule:sendReleaseEmail')}</h2>
          <hr />

          {showNoEmployeesToSendEmailsMsg ? (
            <p>{i18n.t('schedule:noEmployeesToSendEmail')}</p>
          ) : (
            <>
              <ModalTableOfEmployees
                label='sendConfirmedReleaseEmails'
                employees={releaseModalData.confirmedEmployees}
                rowStyle='emailConfirmed'
              />
              <br />
              <ModalTableOfEmployees
                label='sendUnconfirmedReleaseEmails'
                employees={releaseModalData.unconfirmedEmployees}
                rowStyle='emailSent'
              />
            </>
          )}

          {this.generateAdditionalDetails()}

          <div className="blockHeader">
            {!showNoEmployeesToSendEmailsMsg && (
              <Button
                variant="contained"
                className="ssenseButton ssensePrimary"
                onClick={onClickSendReleaseEmails}
              >
                {i18n.t('schedule:sendEmails')}
              </Button>
            )}
            <Button
              variant="contained"
              className="ssenseButton ssenseDefault"
              onClick={onCloseReleaseModal}
            >
              {i18n.t('cancel')}
            </Button>
          </div>
        </Paper>
      </Modal>
    );
  }
}

SendReleaseModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  onCloseReleaseModal: PropTypes.func.isRequired,
  onClickSendReleaseEmails: PropTypes.func.isRequired,
  releaseModalData: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired
};

export default SendReleaseModal;
